import { NativeDateAdapter } from '@angular/material/core';

export class FirstDayDateAdapter extends NativeDateAdapter {
	override getFirstDayOfWeek(): number {
		return 1;
	}
}
